<template>
    <div class="std-margin-btm-1">
        <v-layout align-end justify-space-between>
            <v-btn small color="grey lighten-2" class="navigateBtn"><i class="fas fa-angle-left" /></v-btn>
            <div>	
                <v-btn small color="grey lighten-2" class="backBtn"><i class="fas fa-arrow-left" />&nbsp <p class="backBtnText">&nbspBACK</p></v-btn>&nbsp 
                <v-btn small color="grey lighten-2" class="navigateBtn"><i class="fas fa-angle-right" /></v-btn>
            </div>
        </v-layout>
    </div>
</template>

<script>
export default {
    data () {
        return {
            msg: "PreviousNavigationLink",
        };
    },
};
</script>


// WEBPACK FOOTER //
// src/smallComponents/PreviousNavigationList.vue